// Global Styles
import { cn } from "@/lib/utils";
import { AppBar, Box, Stack, styled, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

// Tailwind CSS equivalent using a functional component and className
export const PageWrapper = ({ children, className = "", ...props }) => (
	<div
		className={cn(`px-6 flex flex-col items-start gap-3 flex-1 overflow-y-auto bg-white mb-3 [&_*]:!font-sans` ,className)}
		{...props}
	>
		{children}
	</div>
);


export const NoRecordsText = ({ children, className, ...props }) => {
  return (
    <p
      className={cn(
        "text-sm text-gray-500 text-center not-italic",
        className
      )}
      {...props}
    >
      {children}
    </p>
  )
}


export const TableWrapper = styled("div")(({ theme }) => ({
    "& .chipContainer": {
      display: "flex",
      flexWrap: "wrap",
      gap: 5,
      maxWidth: "100%", // Ensure chips don't overflow the container
      overflow: "hidden",
    },
    "& .MuiChip-root": {
      height: "22px",
    },
    "& .subChipText": {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "18px",
    },
    "& .MuiBox-root": {
      boxShadow: "none",
    },
    "& .MuiIconButton-root": {
      padding: "0px",
      fontSize: "1.25rem",
      color: "#999999",
    },
	"& .MuiTableRow-root": {
		boxShadow: "none",
	},
    "& .MuiTableRow-root:hover td:after": {
      backgroundColor: "#FFFFFF !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      fontWeight: 400,
	  padding: '4px 10px ',
    },
    "& .MuiCollapse-root": {
      width: "100%",
    },
    "& .Mui-TableBodyCell-DetailPanel": {
      padding: "1px",
    },
  }));
// Tailwind CSS equivalent using a functional component and className
export const ContentWrapper = ({ children, className = "", ...props }) => (
	<div
		className={cn(`flex flex-col items-start gap-3 py-6 pb-2 w-full`,className)}
		{...props}
	>
		{children}
	</div>
);

export const CardWrapper = styled("div")(({ theme }) => ({
	width: "100%",
	position: "relative",
	display: "flex",
	flexDirection: "row",
	alignItems: "flex-start",
	justifyContent: "flex-start",
	boxSizing: "border-box",
	gap: "var(--gap-xs)",
	textAlign: "left",
	color: theme.palette.text.main,
	fontFamily: "var(--default-font)",
	flexWrap: "wrap",
}));

export const TopNavWrapper = styled(AppBar)(({ theme }) => ({
	width: "100%",
	display: "flex",
	justifyContent: "space-between",
	backgroundColor: theme.palette.background.primary,
	boxShadow: "none",
	paddingTop: "1rem",
	flexDirection: "column",
	zIndex: 9,
	top: 0,
	position: "sticky",
	padding: "24px 34px",
	backgroundImage: "none",
	paddingBlock: 20,
	borderBottom: `0.2px solid ${theme.palette.borderColor}`,
}));

export const StyledTitle = ({id,...props}) => {
	const { sx, ...others } = props;
	const theme = useTheme();
	return (
		<Box
			sx={{
				backgroundColor: theme.palette.background.secondary,
				paddingBlock: theme.spacing(1.25),
				paddingInline: theme.spacing(3),
				borderRadius: theme.spacing(1.5),
				width: "100%",
				marginBottom: '10px',
				...sx
			}}
			{...others}
		/>
	)
}

export const ContainerWrapper = ({
  id,
  isGap = true,
  className,
  children,
  ...props
}) => {
  return (
    <div
      id={id}
      className={cn(
        "flex flex-col rounded-2xl bg-muted/50 p-6 pt-6 pb-4",
        isGap ? "gap-5" : "gap-0",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
export const BackgroundWrapper = ({id,...props}) => {
	const { sx, ...others } = props;
	const theme = useTheme();
	return (
		<Box 
		sx={{
			backgroundColor: theme.palette.background.secondary,
			...sx
		}}
		{...others}
		/>
	)
}
export const BackgroundWrapperNew = ({id,...props}) => {
	const { sx, ...others } = props;
	const theme = useTheme();
	return (
		<Box 
		sx={{
			backgroundColor: theme.palette.background.primary,
			borderRadius:'8px',
			padding:'16px',
			border: `1px solid rgba(226, 232, 240, 1)`,
			...sx
		}}
		{...others}
		/>
	)
}
export const WhiteBackgroundTitledInput =({id,...props}) => {
	const { sx,style,className,...others } = props
	return (
		<div
		className={cn("bg-white dark:bg-black rounded-md flex-grow gap-2 py-4 px-5",className)}
		style={{...sx,...style}}
		{...others}
		/>
	);
};

export const DescriptionText = ({ descriptionText, className, ...props }) => {
  return (
    <div className="flex font-sans mt-1 mb-1">
      <p className={cn("text-sm text-muted-foreground", className)} {...props}>
        {descriptionText}
      </p>
    </div>
  );
};
